module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Baltschieder_COA-33dc4ddf3fbdb935cf8f867a9c50a3f7.svg";